import React from 'react';
import './FornecedoresCards.css';

import Adere from '../../assets/fornecedores/adere.png';
import BakofTec from '../../assets/fornecedores/bakof-tec.png';
import Baricar from '../../assets/fornecedores/baricarplast.png';
import Blukit from '../../assets/fornecedores/blukit.png';
import BomCorte from '../../assets/fornecedores/bomcorte.png';
import Cortag from '../../assets/fornecedores/cortag.png';
import Deca from '../../assets/fornecedores/deca.png';
import GbLuvas from '../../assets/fornecedores/gb-luvas.png';
import Herc from '../../assets/fornecedores/herc.png';
import Hydra from '../../assets/fornecedores/hydra.png';
import IvPlast from '../../assets/fornecedores/iv-plast.png';
import Kalipso from '../../assets/fornecedores/kalipso.png';
import Krona from '../../assets/fornecedores/krona.png';
import Metasul from '../../assets/fornecedores/metasul.png';
import Mucambo from '../../assets/fornecedores/mucambo.png';
import Norton from '../../assets/fornecedores/norton.png';
import Overtime from '../../assets/fornecedores/overtime.png';
import Plastcor from '../../assets/fornecedores/plastcor.png';
import Plastilit from '../../assets/fornecedores/plastilit.png';
import Roma from '../../assets/fornecedores/roma.png';
import TekBond from '../../assets/fornecedores/tek-bond.png';
import Unipega from '../../assets/fornecedores/unipega.png';
import Wd40 from '../../assets/fornecedores/wd-40.png';

function FornecedoresCard() {
  return (
    <>
      <div className="fornecedores-card">
        <div className="card-image">
          <img
            src={Adere}
            alt="Adere"
            style={{maxWidth: "250px"}}
          />
        </div>        
        <h3>Adere</h3>
        <p>Fundada em 1967, somos a maior empresa de capital nacional fabricante de fitas adesivas no Brasil.
        No segundo semestre de 2005, uma nova planta foi inaugurada na cidade de Sumaré, interior do Estado de São Paulo - com 174 mil metros quadrados de terreno e localizada estrategicamente em uma região com completa infra-estrutura e próxima de rodovias, ferrovias e aeroporto.</p>
      </div>
      <div className="fornecedores-card">
        <div className="card-image">
          <img
            src={BakofTec}
            alt="BakofTec"
            style={{maxWidth: "250px"}}
          />
        </div>        
        <h3>Bakof Tec</h3>
        <p>Fundada em 1987, a Bakof Tec, empresa de Frederico Westphalen, interior do Rio Grande do Sul, busca desenvolver soluções inovadoras para o armazenamento e proteção à vida. A empresa é pioneira no segmento de Fibra de Vidro e Polietileno. Inicialmente, a Bakof produzia móveis em fibra e antenas parabólicas.</p>
      </div>
      <div className="fornecedores-card">
        <div className="card-image">
          <img
            src={Baricar}
            alt="Baricar"
            style={{maxWidth: "250px"}}
          />
        </div>
        <h3>Baricar Plast</h3>
        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
      </div>
      <div className="fornecedores-card">
        <div className="card-image">
          <img
            src={Blukit}
            alt="Blukit"
            style={{maxWidth: "250px"}}
          />
        </div>
        <h3>{"Blukit"}</h3>
        <p>A Blukit iniciou suas atividades em 1989 na cidade de Blumenau, Santa Catarina, quando lançou no mercado um produto inovador e inusitado para a época batizando-o como Kit Conversor para Registros. Esse produto projetou a empresa por possibilitar o intercâmbio entre bases de registros e acabamentos das mais variadas marcas disponíveis no mercado, fato impossível até o seu surgimento.</p>
      </div>
      <div className="fornecedores-card">
        <div className="card-image">
          <img
            src={BomCorte}
            alt="BomCorte"
            style={{maxWidth: "250px"}}
          />
        </div>
        <h3>Bomcorte Ferramentas</h3>
        <p>Somos uma empresa nacional especializada em ferramentas de corte para todos os segmentos. Contamos com modernos equipamentos e uma equipe técnica altamente qualificada. Trabalhamos com representantes em todo o Brasil preparados para prestar o melhor atendimento a você nosso cliente. Oferecemos produtos com a mais alta qualidade e com ótimos preços.</p>
      </div>
      <div className="fornecedores-card">
        <div className="card-image">
          <img
            src={Cortag}
            alt="Cortag"
            style={{maxWidth: "250px"}}
          />
        </div>
        <h3>Cortag Revolution Tools</h3>
        <p>A Cortag é líder de mercado no segmento de cortadores para pisos cerâmicos e porcelanato em todo o Brasil. O resultado foi apontado pelos lojistas através de pesquisas realizadas por órgãos competentes do ramo de materiais para construção.</p>
      </div>
      <div className="fornecedores-card">
        <div className="card-image">
          <img
            src={Deca}
            alt="Deca"
            style={{maxWidth: "250px"}}
          />
        </div>
        <h3>Deca</h3>
        <p>Design, qualidade e inovação sempre foram conceitos que diferenciaram a Deca ao longo de sua história. São eles que fazem da empresa a maior fabricante de louças e metais sanitários do Hemisfério Sul e líder no mercado brasileiro, além de exportadora para os quatro continentes. Investindo constantemente em pesquisa e desenvolvimento tecnológico, a Deca se preocupa em oferecer produtos e soluções para clientes e consumidores, sempre buscando a excelência em serviços e uma gestão sustentável.</p>
      </div>
      <div className="fornecedores-card">
        <div className="card-image">
          <img
            src={GbLuvas}
            alt="GbLuvas"
            style={{maxWidth: "250px"}}
          />
        </div>
        <h3>GB Luvas</h3>
        <p>Fundada no ano de 2003, GB LUVAS está localizada na  capital gaúcha, Porto Alegre. É especializada em Luvas de Vaqueta modelo petroleira. Nossa missão é proteger a vida das pessoas no ambiente de trabalho. Buscamos sempre a excelência no atendimento aos nossos clientes, trabalhando com produtos de alta qualidade, elaborados com matéria prima selecionada e tecnologia de ponta.</p>
      </div>
      <div className="fornecedores-card">
        <div className="card-image">
          <img
            src={Herc}
            alt="Herc"
            style={{maxWidth: "250px"}}
          />
        </div>
        <h3>HERC</h3>
        <p>Essa história de pioneirismo e perseverança começa com o sonho de quatro amigos em fabricar uma torneira de plástico. Era uma ideia visionária, inédita no mundo, e o sonho começou a virar realidade em 12 de setembro de 1963, com a fundação da Indústria de Plásticos HERC Ltda. De lá para cá, muita coisa aconteceu. Além da torneira novos produtos foram desenvolvidos e, embora a HERC já possua mais de 55 anos, continua em sintonia com a sua época e, atenta ao mercado, pauta sua atuação pela inovação. Inovação que, aliada à experiência e à credibilidade alcançada ao longo do tempo, faz a empresa ser líder e experimentar um crescimento constante.</p>
      </div>
      <div className="fornecedores-card">
        <div className="card-image">
          <img
            src={Hydra}
            alt="Hydra"
            style={{maxWidth: "250px"}}
          />
        </div>
        <h3>Hydra</h3>
        <p>Somos uma empresa brasileira, privada e de capital aberto, controlada pela Itaúsa – Investimentos Itaú S.A – e pela Companhia Ligna de Investimentos.
        Com sede em São Paulo, possuímos 7 unidades florestais e 15 unidades industriais no Brasil, 3 fábricas na Colômbia e 29% das ações da plataforma Viva Decora. Somos parte do dia a dia das cidades e da vida das pessoas por meio das marcas Deca, Hydra, Ceusa, Durafloor e Duratex. Sempre comprometidos com a qualidade, design, sustentabilidade e tecnologia de ponta, oferecemos soluções para melhor viver para cada um de nossos clientes e consumidores com um portfólio de alternativas para a construção e decoração de suas casas, escritórios e demais ambientes.</p>
      </div>
      <div className="fornecedores-card">
        <div className="card-image">
          <img
            src={IvPlast}
            alt="IvPlast"
            style={{maxWidth: "250px"}}
          />
        </div>
        <h3>IV Plast</h3>
        <p>Em Pindamonhangaba desde a sua fundação há 20 anos, a IVPLAST foi criada pelo Sr.Silva que percebeu a grande demanda que existia para esse mercado de Buchas de fixação. Como muitas empresas no Brasil, nasceu pequena e foi se desenvolvendo ao longo dos anos.
        Caracteriza-se como uma empresa familiar, mas com preocupações com o desenvolvimento constante, busca pela qualidade de seus produtos, investimentos em tecnologia e o aperfeiçoamento de seus colaboradores, o que asseguram à empresa solidez e posição de destaque no mercado.</p>
      </div>
      <div className="fornecedores-card">
        <div className="card-image">
          <img
            src={Kalipso}
            alt="Kalipso"
            style={{maxWidth: "250px"}}
          />
        </div>
        <h3>Kalipso</h3>
        <p>Desde nossa fundação, sempre acreditamos ser possível fazer mais. Desejamos que nosso empenho continue a vencer barreira e agregar valor e êxito nos mais diversos segmentos produtivos. Colaboraremos sempre com tecnologia de ponta e qualidade.</p>
      </div>
      <div className="fornecedores-card">
        <div className="card-image">
          <img
            src={Krona}
            alt="Krona"
            style={{maxWidth: "250px"}}
          />
        </div>
        <h3>Krona Tubos e Conexões</h3>
        <p>Uma marca referência em qualidade, credibilidade e confiança. A KRONA é reconhecida nacionalmente como uma das maiores empresas de Tubos e Conexões do Brasil, além de estar entre as maiores empresas do país, segundo o jornal Valor Econômico. Os produtos são fabricados em conformidade com as normas técnicas da ABNT, que passam por um rigoroso controle de qualidade para chegar até a sua construção com a melhor garantia do mercado. A empresa também participa e é certificada pelo Programa Brasileiro da Qualidade e Produtividade do Habitat – PBQPH.</p>
      </div>
      <div className="fornecedores-card">
        <div className="card-image">
          <img
            src={Metasul}
            alt="Metasul"
            style={{maxWidth: "250px"}}
          />
        </div>
        <h3>Metasul</h3>
        <p>"Construir com qualidade" sempre foi o forte da Metasul e foi com essa filosofia que, em 1992 em Braço do Norte, Santa Catarina, iniciou-se sua história. No começo, a empresa produzia apenas baldes de aço para concreto. Já em 1996, atenta às necessidades do mercado, passou a fabricar também produtos à base de plástico.</p>
      </div>
      <div className="fornecedores-card">
        <div className="card-image">
          <img
            src={Mucambo}
            alt="Mucambo"
            style={{maxWidth: "250px"}}
          />
        </div>
        <h3>Mucambo Profissional</h3>
        <p>Com mais de 60 anos de mercado a marca Mucambo, é pioneira na produção de luvas de látex, luvas cirúrgicas e procedimento, sua fábrica está localizada em Ilhéus no estado da Bahia. Recentemente todo o grupo foi adquirido pela empresa Jarden Corporation um grupo líder em uma gama diversificada de produtos de consumo.</p>
      </div>
      <div className="fornecedores-card">
        <div className="card-image">
          <img
            src={Norton}
            alt="Norton"
            style={{maxWidth: "250px"}}
          />
        </div>
        <h3>Norton<br></br>Saint-Gobain</h3>
        <p>Líder em tecnologia, a Norton se estabelece como uma empresa de vanguarda oferecendo sempre as soluções mais adequadas às demandas dos usuários. A cada ano são feitos substanciais investimentos em Pesquisa &amp; Desenvolvimento que ajudam a gerar idéias inovadoras visando revolucionar os processos de abrasivos.</p>
      </div>
      <div className="fornecedores-card">
        <div className="card-image">
          <img
            src={Overtime}
            alt="Overtime"
            style={{maxWidth: "250px"}}
          />
        </div>
        <h3>Overtime</h3>
        <p>Empresa especializada em soluções inteligentes. O mais famoso fornecedor do "ralinho japonês", também industrializa dezenas de outros produtos em aço inox. Acesse a lista completa dos produtos Overtime Jap e escolha o seu.</p>
      </div>
      <div className="fornecedores-card">
        <div className="card-image">
          <img
            src={Plastcor}
            alt="Plastcor"
            style={{maxWidth: "250px"}}
          />
        </div>
        <h3>Plastcor</h3>
        <p>A Plastcor do Brasil foi constituída em 27 de setembro de 2001 e vem atuando com solidez e eficiência, destacando-se como líder na venda de capacetes de segurança e cones de sinalização. Com o objetivo de atender a seus clientes e parceiros de forma diferenciada e personalizada, segue no sentido de fazer melhorias contínuas e desenvolver novos produtos, oferecendo soluções em equipamentos de proteção individual e sinalização, eficazes e totalmente integrados com foco nos clientes.</p>
      </div>
      <div className="fornecedores-card">
        <div className="card-image">
          <img
            src={Plastilit}
            alt="Plastilit"
            style={{maxWidth: "250px"}}
          />
        </div>
        <h3>Plastilit</h3>
        <p>A Plastilit é uma das maiores indústrias de conexões, tubos e acessórios de PVC para sistema predial do Brasil. Uma empresa sólida com mais de 33 anos de experiência que conquistou o mercado com ótimos produtos e excelente atendimento. Com planta fabril instalada na Região Metropolitana de Curitiba, no município de Fazenda Rio Grande, a Plastilit hoje é uma referência de qualidade, pois seus produtos são produzidos com os mais modernos equipamentos e as melhores matérias-primas do mundo. Este diferencial garante a sua qualidade, digna de tornar a Plastilit uma marca exclusiva em muitas lojas no país.</p>
      </div>
      <div className="fornecedores-card">
        <div className="card-image">
          <img
            src={Roma}
            alt="Roma"
            style={{maxWidth: "250px"}}
          />
        </div>
        <h3>Roma Pincéis e Acessórios</h3>
        <p>Roma Pincéis e Acessórios (PINCÉIS ROMA LTDA.) foi fundada no ano de 1989, em Nova Roma do Sul, cidade de 3.500 habitantes que está situada no estado do Rio Grande do Sul, Brasil. Seu início foi marcado pela produção de escovas e materiais para acabamento de calçados. Através do contato constante com o mercado, a empresa identificou a necessidade de ampliar seu mix de produtos. Começou então a fabricar pincéis, trinchas, rolos e outros acessórios diversos para a execução de pinturas.</p>
      </div>
      <div className="fornecedores-card">
        <div className="card-image">
          <img
            src={TekBond}
            alt="TekBond"
            style={{maxWidth: "250px"}}
          />
        </div>
        <h3>TekBond<br></br>Saint-Gobain</h3>
        <p>Presente no mercado desde 2002 e com sede em Embu das Artes, SP, a Tekbond é uma empresa especializada na produção e na importação de diversos produtos como: adesivos instantâneos, selantes, travas químicas, silicones, entre outros. A empresa apresenta crescimento sustentável por meio da construção de parcerias sólidas e do desenvolvimento contínuo de novos produtos.</p>
      </div>
      <div className="fornecedores-card">
        <div className="card-image">
          <img
            src={Unipega}
            alt="Unipega"
            style={{maxWidth: "250px"}}
          />
        </div>
        <h3>Unipega</h3>
        <p>Com mais de 20 anos de experiência no setor, somos a empresa líder na América Latina na fabricação, exportação e distribuição de Tecnologia Híbrida. Nossa linha de adesivos, espumas e selantes é desenvolvida especificamente para o mercado latino-americano, levando em consideração as diferentes culturas, climas e realidades deste continente.</p>
      </div>
      <div className="fornecedores-card">
        <div className="card-image">
          <img
            src={Wd40}
            alt="Wd40"
            style={{maxWidth: "250px"}}
          />
        </div>
        <h3>WD40</h3>
        <p>A latinha azul e amarela de WD-40 Produto Multiusos tem sido por mais de 60 anos a grande favorita para solucionar os mais diversos tipos de problemas ao redor do mundo. Hoje nós temos WD-40 Produto Multiusos em casa, na garagem, no trabalho, no lazer.. e onde mais precisarmos, inclusive para usos fora do comum.</p>
      </div>
    </>
  );
};

export default FornecedoresCard;